import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const useGetUserinfo = () => {
  const { getUserinfo } = useServicesContext();

  return useQuery({
    queryKey: ['GET_USERINFO'],
    queryFn: getUserinfo,
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
  });
};
